module.exports = __webpack_public_path__ + "img/w3_spinner_dark.ecb78263.ecb78263.png";